import React, { PureComponent } from 'react';
import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { cloneDeep } from 'lodash/fp';
import moment from 'moment';
import uniqid from 'uniqid';
import faker from 'faker';
import PropTypes from 'prop-types';

class TrendingChart extends PureComponent {
  constructor(props) {
    super(props);
    this.gradient = uniqid();
    this.end = Math.round(new Date().getTime() / 1000); // in seconds
    this.start = Math.round(moment(this.end * 1000).add(-3, 'months').toDate().getTime() / 1000); // in seconds
    this.state = {
      series: this.generateSeries(this.start, this.end, 3600 * 4) // per 4 hours
    };
  }

  generateSeries(start, end, step) {
    const result = [];
    for (let i = start; i < end; i += step) {
      result.push({
        time: i,
        value: faker.datatype.number({ min: 100, max: 900 })
      });
    }
    return result;
  }

  handleSeries() {
    const result = [];
    const series = cloneDeep(this.state.series);
    for (let i = 0; i < series.length; i++) {
      let found = false;
      switch (this.props.duration) {
        case 'day':
          found = series[i].time >= this.end - 86400;
          break;
        case 'week':
          found = series[i].time >= this.end - 86400 * 7;
          break;
        case 'month':
          const start = Math.round(moment(this.end * 1000).add(-1, 'month').toDate().getTime() / 1000);
          found = series[i].time >= start;
          break;
        case 'all':
          found = true;
          break;
        default:
          found = false;
          break;
      }
      if (found) {
        result.push(series[i]);
      }
    }
    return result;
  }

  render() {
    return (
      <ResponsiveContainer height={this.props.height}>
        <AreaChart
          data={this.handleSeries()}
          layout="vertical"
        >
          <defs>
            <linearGradient id={this.gradient} x1="1" y1="0" x2="0" y2="0">
              <stop offset="0%" stopColor="#9AC802" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#9AC802" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis type="number" hide />
          <YAxis dataKey="time" type="category" hide />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#9AC802"
            fill={`url(#${this.gradient})`}
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}

TrendingChart.propTypes = {
  height: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired
};

export default TrendingChart;
